import { useState } from "react";
import { Download, Sparkles, RefreshCw, Copy, Check } from "lucide-react";
import { StatusPill } from "./shared";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function GeneratedAsset({ asset, onGenerate, ratio = "9 / 16", width = 300 }) {
  const busy = asset.status === "generating";
  return (
    <div className="card fade-up" data-testid={`asset-${asset.id}`} style={{ padding: 20, width: width + 40 }}>
      <div style={{ width, aspectRatio: ratio, borderRadius: 14, overflow: "hidden", background: "var(--blush)", display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
        {asset.url ? (
          <img data-testid={`asset-img-${asset.id}`} src={`${BACKEND_URL}${asset.url}?t=${asset.created_at}`} alt={asset.title} style={{ width: "100%", height: "100%", objectFit: "cover", opacity: busy ? .4 : 1, transition: "opacity 300ms" }} />
        ) : (
          <div className={busy ? "shimmer" : ""} style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
            {!busy && <Sparkles size={28} color="var(--burgundy)" strokeWidth={1.5} />}
          </div>
        )}
        {busy && <span className="pulse-dot serif" style={{ position: "absolute", fontSize: 22, color: "var(--burgundy)", fontStyle: "italic" }}>rendering…</span>}
      </div>
      <div style={{ marginTop: 16, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10 }}>
        <div style={{ fontSize: 13, fontWeight: 600, lineHeight: 1.3 }}>{asset.title}</div>
        <StatusPill status={asset.status} />
      </div>
      <div style={{ fontSize: 11, color: "var(--ink-40)", marginTop: 4 }}>{asset.width}×{asset.height}{asset.reference ? " · anchored to reference sheet" : ""}</div>
      {asset.status?.startsWith("error") && <div data-testid={`asset-error-${asset.id}`} style={{ fontSize: 11, color: "var(--burgundy)", marginTop: 6 }}>{asset.status}</div>}
      <div style={{ display: "flex", gap: 8, marginTop: 14 }}>
        <button className={`btn ${asset.url ? "btn-ghost" : "btn-primary"}`} data-testid={`generate-${asset.id}`} disabled={busy} onClick={() => onGenerate(asset.id)}>
          {asset.url ? <RefreshCw size={14} /> : <Sparkles size={14} />}{asset.url ? "Regenerate" : "Generate"}
        </button>
        {asset.url && (
          <a className="btn btn-ghost" data-testid={`download-${asset.id}`} href={`${BACKEND_URL}${asset.url}`} download={`${asset.id}.png`} target="_blank" rel="noreferrer">
            <Download size={14} />PNG
          </a>
        )}
      </div>
    </div>
  );
}

export function CopyButton({ text, id }) {
  const [done, setDone] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(text); } catch (e) { /* clipboard unavailable */ }
    setDone(true); setTimeout(() => setDone(false), 1600);
  };
  return (
    <button className="btn btn-ghost" data-testid={`copy-${id}`} onClick={copy}>
      {done ? <Check size={14} /> : <Copy size={14} />}{done ? "Copied" : "Copy prompt"}
    </button>
  );
}
